var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dcrkc2ll3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v1641H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s71825kkmb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.412 0v18.274H0V0h20.412z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7b8sx6209c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 0c1.17 0 2.13.075 2.91.3.72.21 1.23.54 1.68.877.765.593 1.305 1.425 1.53 2.018l.008-.007c.465 1.2.472 2.55.472 3.405v10.8c0 .854 0 2.212-.473 3.404a5.048 5.048 0 0 1-1.537 2.018c-.435.337-.967.66-1.688.877-.772.233-1.724.308-2.902.308H6.6c-1.177 0-2.13-.075-2.902-.3-.72-.21-1.245-.54-1.688-.877-.765-.593-1.305-1.425-1.537-2.018C.007 19.605 0 18.255 0 17.4V6.394c.004-.856.043-2.09.472-3.192A5.048 5.048 0 0 1 2.01 1.186c.435-.338.968-.66 1.688-.878C4.47.075 5.422 0 6.6 0zm.075 7.905c-1.665 0-2.895.975-2.895 2.34 0 1.118.697 1.778 2.265 2.175l1.05.27c1.253.315 1.8.787 1.8 1.575 0 .952-.907 1.643-2.175 1.643-1.328 0-2.28-.69-2.37-1.703h-.803c.083 1.455 1.328 2.43 3.098 2.43 1.875 0 3.067-.975 3.067-2.46 0-1.178-.712-1.83-2.415-2.258l-.915-.232c-1.244-.315-1.77-.742-1.77-1.47 0-.93.87-1.582 2.04-1.582 1.2 0 2.048.637 2.123 1.59h.803c-.053-1.343-1.253-2.318-2.903-2.318zm-7.8.007c-2.355 0-3.84 1.688-3.84 4.365 0 2.678 1.485 4.358 3.84 4.358 2.355 0 3.84-1.68 3.84-4.358 0-2.677-1.485-4.364-3.84-4.364zm-4.92 3.256h-.893V16.5h.893v-5.332zm4.92-2.513c1.852 0 3.022 1.402 3.022 3.623 0 2.212-1.17 3.614-3.022 3.614-1.853 0-3.015-1.402-3.015-3.614 0-2.22 1.162-3.623 3.015-3.623zm-5.363.503a.554.554 0 0 0-.555.555.559.559 0 0 0 1.118 0 .56.56 0 0 0-.563-.555z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2rrdek3ikd",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7",
    offset: "59.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcrkc2ll3a)",
    transform: "translate(-478 -834)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s71825kkmb)",
    transform: "translate(479.453 837.438)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M0 0h20.412v18.274H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7b8sx6209c)",
    transform: "translate(478 834)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#2rrdek3ikd)",
    d: "M0 0h24v24H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.d027c98402d3764c5f8486dafe453752.svg";
export { ForwardRef as ReactComponent };